import { ApiFetchParams, ApiQueryOptions, getQueryFn, useApiQuery } from "../helpers/useApi";
import { apiFetch } from "./fetch";

export const DOWNLOADER_API_PATH = '/data/downloader/v1';
export interface ReportOverviewApiResponse<T> {
    dashboard: T;
}


export interface ReportCategory {
    id: number;
    displayKey: string;
}

export type AvailableFilters = 'time' | 'location' | 'locationArea' | 'staff' | 'device' | 'deviceGroup' | 'deviceType' | 'paymentMethod';

export interface ReportOverviewItem {
    id: number;
    displayKey: string;
    descDisplayKey: string;
    category: ReportCategory;
    addedOn: string;
    isManual: boolean;
    isAutomated: boolean;
    isFavourite: boolean;
    availableFilters: AvailableFilters[];
}

export interface CreateReportBody {
    name: string;
    reportTypeId: number;
    startDate: Date;
    endDate: Date;
    fileType: string;
    filters: string;
    locale: string;
}

export function useReportOverview<T>(queryKey: string) {
    return useApiQuery<T>({
        path: `${DOWNLOADER_API_PATH}/report-types`,
        body: {}
    } as ApiFetchParams, queryKey);
}

export function updateFavoriteReportOverview(id: number, favourite: boolean, maybeAccessToken?: string) {

    return getQueryFn<object>(
        {
            path: `${DOWNLOADER_API_PATH}/report-types/${id}/favourite`,
            method: 'PUT',
            body: { "isFavourite": favourite },
        },
        (
            body: unknown = {},
            path = '/',
            method = 'GET',
            endpoint: string | undefined = process.env.REACT_APP_API_DOWNLOADER,
            authorization: string | undefined = `Bearer ${maybeAccessToken}`
        ) => apiFetch<object>(path, body, method, endpoint, authorization)
    )();
}

export function createReport(report: CreateReportBody, maybeAccessToken?: string) {

    return getQueryFn<object>(
        {
            path: `${DOWNLOADER_API_PATH}/reports`,
            method: 'POST',
            body: report,
        },
        (
            body: unknown = {},
            path = '/',
            method = 'GET',
            endpoint: string | undefined = process.env.REACT_APP_API_DOWNLOADER,
            authorization: string | undefined = `Bearer ${maybeAccessToken}`
        ) => apiFetch<object>(path, body, method, endpoint, authorization)
    )();
}
